import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background-color: #ffffff;\n  height: 240px;\n  width: 100%;\n  p {\n    color: ",
        ";\n    margin-top: 16px;\n    font-size: 16px;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import Image from "next/image";
import themeGet from "@styled-system/theme-get";
export const SearchFilteredProductEmpty = (param)=>{
    let {} = param;
    return /*#__PURE__*/ _jsxs(SearchFilteredProductEmptyWrapper, {
        children: [
            /*#__PURE__*/ _jsx(Image, {
                src: "/static/assets/img-construction-01.svg",
                alt: "icon",
                width: 90,
                height: 90
            }),
            /*#__PURE__*/ _jsx("p", {
                children: "필터와 일치하는 상품을 찾을 수 없어요"
            })
        ]
    });
};
const SearchFilteredProductEmptyWrapper = styled.div.withConfig({
    componentId: "sc-9ffe682e-0"
})(_templateObject(), themeGet("text.2", "#000000"));
